// extracted by mini-css-extract-plugin
export default {"itemsConatiner":"style_itemsConatiner__XAnx3"};